module.exports = __webpack_public_path__ + "static/media/sam2.db076839.png";